/**
 * Хелперы прав доступа для действий с кандидатом
 */

/**
 * Проверяет, может ли пользователь редактировать карточку кандидата
 * @param {string} userRole - Роль текущего пользователя
 * @returns {{canEdit: boolean, reason: string}}
 */
export const canEditCandidate = (userRole) => {
    const role = String(userRole || '');
    if (role === 'superadmin' || role === 'admin' || role === 'hr') {
        return { canEdit: true, reason: '' };
    }
    return { canEdit: false, reason: 'У вас нет прав для редактирования кандидата' };
};

/**
 * Проверяет, может ли пользователь менять статус кандидата
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canChangeCandidateStatus = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, может ли пользователь вернуть кандидата в работу
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canReturnCandidateToWork = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, может ли пользователь создавать задачи по кандидату
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canCreateTaskForCandidate = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, может ли пользователь оставлять комментарии к кандидату
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canCommentOnCandidate = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, может ли пользователь создавать карточку кандидата
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const canCreateCandidate = (userRole) => {
    const role = String(userRole || '');
    return role === 'superadmin' || role === 'admin' || role === 'hr';
};

/**
 * Проверяет, является ли пользователь лидером
 * @param {string} userRole - Роль текущего пользователя
 * @returns {boolean}
 */
export const isLeaderRole = (userRole) => String(userRole || '') === 'leader';


